export default {
  toPay: '/courier/api/stock/saveStockOrderForPay'
}
